<template>
  <div class="fromStyle">
    <a-form :form="form" @submit="handleSubmit">
      <a-form-item label="项目名称" v-bind="formItemLayout">
        <p>{{ project_name }}</p>
      </a-form-item>
      <a-form-item label="预支比例" v-bind="formItemLayout">
        <a-input-number v-model="proportion" />
        <span style="font-size:14px">&nbsp;&nbsp;%</span>
      </a-form-item>
      <a-form-item label="项目负责人" v-bind="formItemLayout">
        <a-select
          showSearch
          :filterOption="filterOption"
          v-model="project_person_id"
          mode="multiple"
        >
          <a-select-option
            v-for="(element, i) in userList"
            :key="i"
            :value="element.id"
            >{{ element.user_name }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
        <a-button type="primary" html-type="submit">提交</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import axios from "axios";
import { pcaa } from "area-data";
export default {
  inject: ["reload"],
  data() {
    return {
      formLayout: "horizontal",
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 12 }
      },
      tradeList: [],
      customerList: "",
      pcaa: pcaa,
      cityVal: ["上海市", "市辖区"],
      province: "",
      city: "",
      editID: "",
      sign_agreement_id: [],
      contractList: [],
      companyList: [],
      userList: [],
      project_person_id: [],
      project_name: "",
      proportion: ""
    };
  },
  mounted() {
    if (this.editDetail != undefined) {
      this.getDetails();
    }
  },
  props: {
    editDetail: {}
  },
  watch: {
    editDetail() {
      this.getDetails();
    }
  },
  methods: {
    getUser() {
      let url =
        this.httpsBasic.url + this.httpsBasic.user + "User/employeeListData";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.userList = res.data.data;
          // console.log(this.userList);
        }
      });
    },
    getDetails() {
      // console.log(this.editDetail.proportion);
      this.editDetail.user_ids == "" && this.editDetail.user_ids != undefined
        ? (this.project_person_id = [])
        : (this.project_person_id = this.editDetail.user_ids
            .split(",")
            .map(Number));
      this.editID = this.editDetail.id;
      this.project_name = this.editDetail.project_name;
      this.proportion = this.editDetail.proportion;
      this.getUser(); //获取用户
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, pramas) => {
        // console.log(pramas.company_id);
        if (!err) {
          let url =
            this.httpsBasic.url +
            this.httpsBasic.trade +
            "Project/setProjectProportion";
          let params = {
            token: window.localStorage.getItem("xnwfPcToken"),
            project_id: this.editDetail.id,
            project_person_id: JSON.stringify(this.project_person_id),
            proportion: this.proportion
          };
          //  console.log(params)
          axios
            .post(url, params)
            .then(res => {
              if (res.data.code == 200) {
                this.$message.success("提交成功");
                this.form.resetFields();
                this.$emit("hideInEdit", false);
              } else {
                this.$message.warning(res.data.message);
              }
            })
            .catch(err => {
              this.$message.error("服务器出错了...");
            });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.fromStyle {
  margin: 12% 4%;
}
</style>

<style lang="less">
.fromStyle {
  .area-select .area-selected-trigger {
    padding: 0 20px 0 12px;
  }
  .area-select {
    line-height: 32px;
  }
  .area-select.medium {
    width: 142px;
  }
}
</style>
